const getCoverPageFields = (index) => {
    return [
        {
            type: 'select',
            key: `usage_${index}`,
            title: 'Tipo de Obra',
            options: [],
            optionConfig: { name: 'usage' },
            loaded: false,
            colSize: 6,
            'element-attr': {
                required: false,
            }
        },
        {
            title: "Imagem da capa",
            key: `cover_image_${index}`,
            type: "image",
            "element-attr": { "required": false },
            colSize: 6,
        }
    ];
}

const coverPageImages = () => {
    return [
        [
            ...getCoverPageFields(0),
            ...getCoverPageFields(1),
        ],
        [
            ...getCoverPageFields(2),
            ...getCoverPageFields(3),
        ],
        [
            ...getCoverPageFields(4),
            ...getCoverPageFields(5),
        ],
        [
            ...getCoverPageFields(6),
            ...getCoverPageFields(7),
        ],
        [
            ...getCoverPageFields(8),
            ...getCoverPageFields(9),
        ],
    ]
}

export default coverPageImages;